import { Web3Provider } from '@ethersproject/providers';
import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { NetworkConnector } from './NetworkConnector';
import { ConnectorNames } from '../constants';
//import { pollingInterval } from '../configs';



export const network = new NetworkConnector({
  urls: {
    1: 'wss://eth-mainnet.alchemyapi.io/v2/9tNnSTTB5lBond6jhoiqnITlwxOdhtX1',
    //4: 'https://localhost/',
  },
  defaultChainId: 1,
});

let networkLibrary: Web3Provider | undefined;
export function getNetworkLibrary(): Web3Provider {
  // eslint-disable-next-line no-return-assign
  return (networkLibrary = networkLibrary ?? new Web3Provider(network.provider as any));
}

export const injected = new InjectedConnector({
  supportedChainIds: [1],
});

// mainnet only
export const walletconnect = new WalletConnectConnector({
  //rpc: { 1: 'wss://eth-mainnet.alchemyapi.io/v2/9tNnSTTB5lBond6jhoiqnITlwxOdhtX1' },
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
  //pollingInterval: pollingInterval,
});

export const connectorsByName: { [connectorName in ConnectorNames]: any } = {
  [ConnectorNames.Injected]: injected,
  [ConnectorNames.WalletConnect]: walletconnect,
}
